
import { Link, useLocation } from 'react-router-dom';
import { FLASHCARD_STUDY_PATH, VOCAB_OPTIONS_PATH,
    GRAMMAR_OPTIONS_PATH, LISTEN_OPTIONS_PATH,
    UNITS_LIST_PATH,
    GAME_OPTIONS_PATH} from '../../constants';
import './StudyOptionsPage.css';
import flashCardsImg from './resources/flash-cards.png';
import vocabularyImg from './resources/vocabulary.png';
import grammarImg from './resources/grammar.png';
import listeningImg from './resources/listening.png';

const studyOptions = [
    {
        category: 'Flashcards',
        path: FLASHCARD_STUDY_PATH,
        img: flashCardsImg,
        title: 'Flashcards'
    },
    {
        category: 'Vocabulary',
        path: GAME_OPTIONS_PATH,
        img: vocabularyImg,
        title: 'Vocabulary Games'
    },
    {
        category: 'Grammar',
        path: GAME_OPTIONS_PATH,
        img: grammarImg,
        title: 'Grammar Games'
    },
    {
        category: 'Listening',
        path: GAME_OPTIONS_PATH,
        img: listeningImg,
        title: 'Listening Games'
    }
];
function StudyOptionsPage() {
    const location = useLocation();
    const unit = location.state;

    return (
        <div id='study-options-page-container'>
            <div className='white-background'>
                <h1>{unit.name}</h1>
                <div className='study-options-grid'>
                    {studyOptions.map(option => (
                        <Link to={option.path} state={{ unit : unit, category: option.category }} key={option.category}>
                            <button className='study-option-button'>
                                <img src={option.img} alt={option.title} className="study-option-img" />
                                <span>{option.title}</span>
                            </button>
                        </Link>
                    ))}
                </div>
                <Link to={UNITS_LIST_PATH} state={unit}>
                    <button className='back-button'>
                        {'Back'}
                    </button>
                </Link>
            </div>
        </div>
    );
}

export default StudyOptionsPage;